var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFitbQuestion = function SvgFitbQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7748_19884)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7748_19884",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_7748_19884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 89,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 45.5,
    x2: 128,
    y2: 45.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 58.5,
    x2: 128,
    y2: 58.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 71.5,
    x2: 58,
    y2: 71.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 71.5,
    x2: 128,
    y2: 71.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 84.5,
    x2: 128,
    y2: 84.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 92.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 97.5,
    x2: 128,
    y2: 97.5,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7748_19884",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7748_19884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7748_19884",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFitbQuestion);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";